module.exports = __webpack_public_path__ + "static/img/wanDaContent2.1c579b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wanDaContent2.png
// module id = UI3x
// module chunks = 2